import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios';
import Select from "react-select";
import Loader from "../../comman/Loader";
import {baseUrl, shopFixCostCategory, shopFixCostPetrol} from "../../comman/config";


import { useNavigate, Link } from 'react-router-dom';

export default function Form({detail}) {
    const today = new Date().toISOString().split("T")[0];
    const user_id = localStorage.getItem("userId");
    const [formData, setFormData] = useState({
        date : today,
        shop_name: '',
        category: '',
        rent_amount: '',
        bill_start_date: '',
        bill_end_date: '',
        bill_amount : '',
        material_name: '',
        material_quantity: '',
        material_amount: '',
        petrol_type: '',
        milkman_petrol : '',
        other_petrol:'',
        petrol_cost: '',
        other_name: '',
        other_quantity: '',
        other_amount: '',
        user_id:user_id
    });
    const [validationErrors, setValidationErrors] = useState({
        date: false,
        shop_name: false,
        category: false,
        rent_amount: false,
        bill_start_date: false,
        bill_end_date: false,
        bill_amount : false,
        material_name: false,
        material_quantity: false,
        material_amount: false,
        petrol_type: false,
        milkman_petrol : false,
        other_petrol:false,
        petrol_cost: false,
        other_name: false,
        other_quantity: false,
        other_amount:false
        
    });
    const [popupOpen , setPopupOpen] = useState(false);
    const [milkManList , setMilkManList] = useState([]);
    const formRef = useRef(null);
    
    
    const navigate = useNavigate();
    useEffect(() => {
        getMilkManList();
    }, []);
    
    useEffect(() => {
        if(detail){
            const milkman = milkManList.find((item) => item.id == detail[0].milkman_petrol);
            const milkManObject = milkman ? {value : milkman.id, label : milkman.name} : {value : "", label : ""};
            setFormData({
                date: detail[0].date || today,
                shop_name : detail[0].shop_name || '',
                category : shopFixCostCategory.find((item) => item.value == detail[0].category),
                rent_amount : detail[0].rent_amount,
                bill_start_date : detail[0].bill_start_date,
                bill_end_date : detail[0].bill_end_date,
                bill_amount : detail[0].bill_amount,
                material_name : detail[0].material_name,
                material_quantity : detail[0].material_quantity,
                material_amount : detail[0].material_amount,
                petrol_type : shopFixCostPetrol.find((item) => item.value == detail[0].petrol_type),
                milkman_petrol : milkManObject,
                other_petrol : detail[0].other_petrol,
                petrol_cost : detail[0].petrol_cost,
                other_name : detail[0].other_name,
                other_quantity : detail[0].other_quantity,
                other_amount : detail[0].other_amount,
                db_id: detail[0]?.id ?? 0
            });
        }
    }, [detail, milkManList]);

    const getMilkManList = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/shop_fix_cost/milkman-list`);
        setMilkManList(response.data.data);
        setPopupOpen(false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newValidationErrors = {
            date: formData.date === '',
            shop_name : formData.shop_name === '',
            category : !formData.category.value,
            rent_amount : formData.category.value == 1 && formData.rent_amount == '',
            bill_amount : (formData.category.value == 2 || formData.category.value == 5) && formData.bill_amount == '',
            material_name : formData.category.value == 3 && formData.material_name == '',
            material_amount : formData.category.value == 3 && formData.material_amount == '',
            petrol_type : formData.category.value == 4 && !formData.petrol_type.value,
            milkman_petrol: formData.category.value == 4 && formData.petrol_type.value == 1 && !formData.milkman_petrol.value,
            petrol_cost: formData.category.value == 4 && formData.petrol_cost == '',
            other_name : formData.category.value == 6 && formData.other_name == '',
            other_amount : formData.category.value == 6 && formData.other_amount == '',
        };
        setValidationErrors(newValidationErrors);
        const hasErrors = Object.values(newValidationErrors).some((error) => error);
        if (hasErrors) {
            
            // Find the first invalid input element
            const firstInvalidInput = formRef.current.querySelector('.invalid');
            if (firstInvalidInput) {
              // Scroll to the first invalid input element
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }else {
            console.log(formData);
            let url;
            try {
                setPopupOpen(true);
                if(detail){
                    url = `shop_fix_cost/edit/${detail[0].id}`;
                }else{
                    url = "shop_fix_cost/add";
                }
                await axios.post(`${baseUrl}/${url}`,{
                    formData: formData,
                });
                setPopupOpen(false);
                navigate("/shop_fix_cost/list");
            } catch (error) {

                setPopupOpen(false);
                console.log(error);
                
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
    
            }));
      
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };

    const handleSelectChange = (data, option) => {
        if(option.name === "category"){
            setFormData((prevData) => {
                const newData = {
                  ...prevData,
                  [option.name]: data,
                };
                if(data.value === 1){
                    return {
                        ...newData,
                        bill_start_date : "",
                        bill_end_date : "",
                        bill_amount : "",
                        material_name : "",
                        material_quantity : "",
                        material_amount : "",
                        petrol_type : "",
                        milkman_petrol : "",
                        other_petrol : "",
                        petrol_cost : "",
                        other_name : "",
                        other_quantity : "",
                        other_amount : ""
                    }
                }else if(data.value === 2 || data.value === 5){
                    return {
                        ...newData,
                        rent_amount: "",
                        material_name : "",
                        material_quantity : "",
                        material_amount : "",
                        bill_start_date : "",
                        bill_end_date : "",
                        bill_amount : "",
                        petrol_type : "",
                        milkman_petrol : "",
                        other_petrol : "",
                        petrol_cost : "",
                        other_name : "",
                        other_quantity : "",
                        other_amount : ""
                    }
                }else if(data.value === 3){
                    return {
                        ...newData,
                        rent_amount: "",
                        bill_start_date : "",
                        bill_end_date : "",
                        bill_amount : "",
                        petrol_type : "",
                        milkman_petrol : "",
                        other_petrol : "",
                        petrol_cost : "",
                        other_name : "",
                        other_quantity : "",
                        other_amount : ""
                    }
                }else if(data.value === 4){
                    return {
                        ...newData,
                        rent_amount: "",
                        bill_start_date : "",
                        bill_end_date : "",
                        bill_amount : "",
                        material_name: '',
                        material_quantity: '',
                        material_amount: '',
                        other_name : "",
                        other_quantity : "",
                        other_amount : ""
                    }
                }else if(data.value === 6){
                    return {
                        ...newData,
                        rent_amount: "",
                        bill_start_date : "",
                        bill_end_date : "",
                        bill_amount : "",
                        material_name: '',
                        material_quantity: '',
                        material_amount: '',
                        petrol_type: '',
                        milkman_petrol : '',
                        other_petrol:'',
                        petrol_cost: '',
                    }
                }
            })
            
              
        }else{
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
              }));
        }
        
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [option.name]: false,
        }));
      };
    

  return (
 
 <form ref={formRef}>
    {popupOpen && (
                     <Loader /> 
                ) }
                <div className="space-y-12">
                    <div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="date" className="block text-sm font-medium leading-6 text-gray-900">Date</label>
                                <div className="mt-2">
                                <input
                                    type="date"
                                    name="date"
                                    id="date"
                                    value={formData.date}
                                    onChange={handleInputChange}
                                    className={`block w-full rounded-md border ${
                                        validationErrors.date ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                />
                                </div>
                                {validationErrors.date && <div className="text-red-500">Please enter a date.</div>}
                            </div>
                            
                            <div className="sm:col-span-2">
                            <label htmlFor="shop_name" className="block text-sm font-medium leading-6 text-gray-900">Shop name</label>
                            <div className="mt-2">
                            
                                
                                <input 
                                  id="shop_name"
                                  name="shop_name"
                                  type="text"
                                  placeholder='Shop name'
                                  value={formData.shop_name}
                                  onChange={handleInputChange}
                                  onWheel={(e) => e.target.blur()}
                                  className={`block w-full rounded-md border ${validationErrors.shop_name ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                    
                                />
                                
                            </div>
                            {validationErrors.shop_name && <div className="text-red-500">Please enter a Shop name.</div>}
                        </div>
                           
                        </div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                        <div className="sm:col-span-2">
                                <label htmlFor="category" className="block text-sm font-medium leading-6 text-gray-900">Category</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.category}
                                        name="category"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={shopFixCostCategory.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.category && <div className="text-red-500">Please select a category.</div>}
                            </div>
                        {formData.category.value == 1 && <div className="sm:col-span-2">
                            <label htmlFor="rent_amount" className="block text-sm font-medium leading-6 text-gray-900">Rent amount</label>
                            <div className="mt-2">
                            
                                
                            <input 
                                      id="rent_amount"
                                      name="rent_amount"
                                      type="number"
                                      placeholder='Rent Amount'
                                      step="0.01"
                                      value={formData.rent_amount}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.rent_amount ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                
                            </div>
                            {validationErrors.rent_amount && <div className="text-red-500">Please enter a rent amount.</div>}
                        </div>}
                        </div>
                        {(formData.category.value == 2 || formData.category.value == 5) && <>
                            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="bill_start_date" className="block text-sm font-medium leading-6 text-gray-900">Bill Start Date</label>
                                <div className="mt-2">
                                <input
                                    type="date"
                                    name="bill_start_date"
                                    id="bill_start_date"
                                    value={formData.bill_start_date}
                                    onChange={handleInputChange}
                                    className={`block w-full rounded-md border ${
                                        validationErrors.bill_start_date ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                />
                                </div>
                                {validationErrors.bill_start_date && <div className="text-red-500">Please enter bill start date.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="bill_end_date" className="block text-sm font-medium leading-6 text-gray-900">Bill End Date</label>
                                <div className="mt-2">
                                <input
                                    type="date"
                                    name="bill_end_date"
                                    id="bill_end_date"
                                    value={formData.bill_end_date}
                                    onChange={handleInputChange}
                                    className={`block w-full rounded-md border ${
                                        validationErrors.bill_end_date ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                />
                                </div>
                                {validationErrors.bill_end_date && <div className="text-red-500">Please enter a bill end date.</div>}
                            </div>
                            <div className="sm:col-span-2">
                            <label htmlFor="bill_amount" className="block text-sm font-medium leading-6 text-gray-900">Bill amount</label>
                            <div className="mt-2">
                            
                                
                            <input 
                                      id="bill_amount"
                                      name="bill_amount"
                                      type="number"
                                      placeholder='Bill Amount'
                                      step="0.01"
                                      value={formData.bill_amount}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.bill_amount ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                
                            </div>
                            {validationErrors.bill_amount && <div className="text-red-500">Please enter a bill amount.</div>}
                        </div>
                            </div>
                        </>}
                        {formData.category.value == 3 && <>
                            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="material_name" className="block text-sm font-medium leading-6 text-gray-900">Material Name</label>
                                <div className="mt-2">
                                <input 
                                  id="material_name"
                                  name="material_name"
                                  type="text"
                                  placeholder='Material name'
                                  value={formData.material_name}
                                  onChange={handleInputChange}
                                  onWheel={(e) => e.target.blur()}
                                  className={`block w-full rounded-md border ${validationErrors.material_name ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                    
                                />
                                </div>
                                {validationErrors.material_name && <div className="text-red-500">Please enter material name.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="material_quantity" className="block text-sm font-medium leading-6 text-gray-900">Material Quantity</label>
                                <div className="mt-2">
                                <input
                                    type="number"
                                    name="material_quantity"
                                    id="material_quantity"
                                    value={formData.material_quantity}
                                    step="0.01"
                                    placeholder='Material Quantity'
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    className={`block w-full rounded-md border ${
                                        validationErrors.material_quantity ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                />
                                </div>
                                {validationErrors.material_quantity && <div className="text-red-500">Please enter a material quantity.</div>}
                            </div>
                            <div className="sm:col-span-2">
                            <label htmlFor="material_amount" className="block text-sm font-medium leading-6 text-gray-900">Material amount</label>
                            <div className="mt-2">
                            
                                
                            <input 
                                      id="material_amount"
                                      name="material_amount"
                                      type="number"
                                      placeholder='Material Amount'
                                      step="0.01"
                                      value={formData.material_amount}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.material_amount ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                
                            </div>
                            {validationErrors.material_amount && <div className="text-red-500">Please enter a material amount.</div>}
                        </div>
                            </div>
                        </>}
                        {formData.category.value == 4 && <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                        <div className="sm:col-span-2">
                                <label htmlFor="petrol_type" className="block text-sm font-medium leading-6 text-gray-900">Petrol Type</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.petrol_type}
                                        name="petrol_type"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={shopFixCostPetrol.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                            {validationErrors.petrol_type && <div className="text-red-500">Please select a petrol type.</div>}
                            </div>
                            {formData.petrol_type.value == 1 && <div className="sm:col-span-2">
                                <label htmlFor="milkman_petrol" className="block text-sm font-medium leading-6 text-gray-900">Milkman</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.milkman_petrol}
                                        name="milkman_petrol"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={milkManList.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.milkman_petrol && <div className="text-red-500">Please select a milkman.</div>}
                            </div>}
                            {formData.petrol_type.value == 2 &&<div className="sm:col-span-2">
                            <label htmlFor="other_petrol" className="block text-sm font-medium leading-6 text-gray-900">Other</label>
                            <div className="mt-2">
                            
                                
                                <input 
                                  id="other_petrol"
                                  name="other_petrol"
                                  type="text"
                                  placeholder='Other'
                                  value={formData.other_petrol}
                                  onChange={handleInputChange}
                                  onWheel={(e) => e.target.blur()}
                                  className={`block w-full rounded-md border ${validationErrors.other_petrol ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                    
                                />
                                
                            </div>
                            {validationErrors.other_petrol && <div className="text-red-500">Please enter a value.</div>}
                        </div>}
                        <div className="sm:col-span-2">
                            <label htmlFor="petrol_cost" className="block text-sm font-medium leading-6 text-gray-900">Petrol Cost</label>
                            <div className="mt-2">
                            
                                
                            <input 
                                      id="petrol_cost"
                                      name="petrol_cost"
                                      type="number"
                                      placeholder='Petrol Cost'
                                      step="0.01"
                                      value={formData.petrol_cost}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.petrol_cost ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                
                            </div>
                            {validationErrors.petrol_cost && <div className="text-red-500">Please enter a petrol cost.</div>}
                        </div>
                            </div>}
                        
                            {formData.category.value == 6 && <>
                            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="other_name" className="block text-sm font-medium leading-6 text-gray-900">Other Name</label>
                                <div className="mt-2">
                                <input 
                                  id="other_name"
                                  name="other_name"
                                  type="text"
                                  placeholder='Other name'
                                  value={formData.other_name}
                                  onChange={handleInputChange}
                                  onWheel={(e) => e.target.blur()}
                                  className={`block w-full rounded-md border ${validationErrors.other_name ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                    
                                />
                                </div>
                                {validationErrors.other_name && <div className="text-red-500">Please enter other name.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="other_quantity" className="block text-sm font-medium leading-6 text-gray-900">Other Quantity</label>
                                <div className="mt-2">
                                <input
                                    type="number"
                                    name="other_quantity"
                                    id="other_quantity"
                                    value={formData.other_quantity}
                                    step="0.01"
                                    placeholder='Other Quantity'
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    className={`block w-full rounded-md border ${
                                        validationErrors.other_quantity ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                />
                                </div>
                                {validationErrors.other_quantity && <div className="text-red-500">Please enter a quantity.</div>}
                            </div>
                            <div className="sm:col-span-2">
                            <label htmlFor="other_amount" className="block text-sm font-medium leading-6 text-gray-900">Other amount</label>
                            <div className="mt-2">
                            
                                
                            <input 
                                      id="other_amount"
                                      name="other_amount"
                                      type="number"
                                      placeholder='Other Amount'
                                      step="0.01"
                                      value={formData.other_amount}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.other_amount ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                
                            </div>
                            {validationErrors.other_amount && <div className="text-red-500">Please enter a amount.</div>}
                        </div>
                            </div>
                        </>}
                    </div>
                </div>
                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <Link to="/shop_fix_cost/list">
                        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
                    </Link>
                    <button
                    onClick={handleSubmit}
                      type="submit"
                      className="rounded-md bg-blue-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Save
                    </button>
                </div>
            </form>
            )
        }